import { Component, OnInit, Input, ViewEncapsulation, Inject, PLATFORM_ID, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { IBannerImageDataModel } from '../../models/banner-image.datamodel';
import { ModelService } from '../../services/model.service';
import { CustomDeviceDetectorService } from '../../services/custom-device-detector.service';
import { JssStylingService } from '../../jss-styling.service';
import { isPlatformServer } from '@angular/common';
import Swiper from 'swiper';
import { JssContextService } from '../../jss-context.service';
import { Subscription } from 'rxjs';
import { Pagination } from 'swiper/modules';

@Component({
  selector: '[app-banner-image]',
  templateUrl: './banner-image.component.html',
  styleUrls: ['./banner-image.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BannerImageComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  @Input() data: IBannerImageDataModel;
  @Input() gallery: boolean = false;
  @Input() index: number;
  @Input() hasBackground: false;
  @Input() isInsideSlider: false;

  public containerClass: any = "lg:pb-flex-row";
  public containerPositionClass: any = "pb-container-right";
  public backgroundColorClass: any = "";
  public simpleMaskClass: any = "pb-banner-mask-left";
  public logoMaskClass: any = "pb-banner-mask-left";
  public isMobile: boolean = false;
  public mask: string = "None";
  dynamicClass: string;
  swiper: Swiper;
  public contextSubscription: Subscription;
  language:string;
  _isPlatformServer: boolean = false;
  @ViewChild('SliderBannerImage', { static: false }) swiperSlider!: ElementRef;

  constructor(private modelService: ModelService,public jssContext: JssContextService, private deviceDetector: CustomDeviceDetectorService,public jssStylingService: JssStylingService, @Inject(PLATFORM_ID) public readonly platformId: string) {

  }

  ngOnInit() {
    this._isPlatformServer = isPlatformServer(this.platformId);
    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this.language = newState.language
    });
    let fields:any;
    // if(!this.data?.title) {
    if(this.rendering) {
      this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
      fields = this.rendering.fields;
      this.data = this.modelService.getBannerImage(fields);
    }
    else {
      this.data.position = "left";
      this.data.mask = "None";
    }

    this.isMobile = this.deviceDetector.isMobile();
    if(this.data?.position == "right" || this.gallery){
      this.containerClass = "lg:pb-flex-row-reverse";
      this.containerPositionClass = "pb-container-left";
    }

    if(this.data?.mask == "Simple"){
      this.mask = fields?.Mask?.value;
      if(this.data?.position == "right"){
        this.containerClass = "lg:pb-flex-row pb-flex-col-reverse";      
        this.simpleMaskClass = "pb-banner-mask-right";    
      }
      else{
        this.containerClass = "pb-flex-col-reverse lg:pb-flex-row-reverse";
        
      }
    }

    if(this.data?.mask == "Logo"){
      this.mask = this.data?.mask;
      if(this.data?.position == "right"){
        this.containerClass = "lg:pb-flex-row pb-flex-col-reverse";      
        this.logoMaskClass = "pb-banner-mask-right";    
      }
      else{
        this.containerClass = "lg:pb-flex-row-reverse"
      }
    }
    if(this.data?.mask == "EmbeddedLogo"){
      this.mask = this.data?.mask;
      if(this.data?.position == "right"){
        this.containerClass = "lg:pb-flex-row pb-flex-col-reverse";      
        this.logoMaskClass = "pb-banner-mask-right";    
      }
      else{
        this.containerClass = "lg:pb-flex-row-reverse"
      }
    }

    if(this.gallery==false) {
        if(this.data?.backgroundColor == "grey") {
            this.backgroundColorClass="pb-banner-image-background-grey pb-pb-4 lg:pb-pb-0";
        }
        else if(this.data?.backgroundColor == "warm-grey") {
            this.backgroundColorClass="pb-banner-image-background-warm-grey pb-pb-4 lg:pb-pb-0";
        }
        else if(this.data?.backgroundColor == "yellow") {
            this.backgroundColorClass="pb-banner-image-background-yellow pb-pb-4 lg:pb-pb-0";
        }
        else return;
    }

  }
  
  ngOnDestroy(): void {
    if (this.contextSubscription) {
        this.contextSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    if (!this._isPlatformServer) {
      if(this.swiperSlider){
        this.swiper = new Swiper(this.swiperSlider?.nativeElement, {
          slidesPerView: "auto",
          centeredSlides: true,
          autoHeight:true,
          spaceBetween: 16,
          grabCursor: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            1024: {
                autoHeight: false,
            }
          },
          modules: [Pagination],
        });
      }
  
    }
  }
}
